export const JWT_TOKEN_COGNITO = "tokenJwt_notrelife"
export const JWT_TOKEN_COGNITO_ID = "idTokenJwt_notrelife"
